import { Card } from '@/ui/Card';
import { estiloDeBoton } from '@/ui/Button';
import { cn } from '@/lib/cn';

/**
 * Plantillas — un puente al Centro de Notificaciones.
 *
 * Las plantillas de correo se crean, se editan y se borran allí, junto a los
 * envíos que las usan. Hasta el 2026-09-15 esta pestaña llamaba a
 * `PageNotifications.renderTemplates(el)` para incrustar aquí el gestor entero;
 * esa pantalla pasó a React y esa función dejó de existir.
 *
 * Se resuelve con un enlace y no montando aquí la pantalla de React, por lo
 * mismo que Administración abre el Directorio en vez de duplicarlo: una raíz de
 * React incrustada es deuda que alguien tiene que cerrar después, y el proyecto
 * cerró la última el 2026-09-18.
 *
 * Que la pestaña siga existiendo es decisión del módulo 17: quien busca «las
 * plantillas» las busca en Administración, así que el atajo se queda.
 */
export function Plantillas() {
  return (
    <Card className="p-6 text-center">
      <i className="bi bi-palette2 text-8 text-muted" aria-hidden="true" />
      <p className="mt-3 text-3 font-semibold text-brand-ink">
        Las plantillas viven en el Centro de Notificaciones
      </p>
      <p className="mx-auto mt-1 max-w-md text-2 text-muted">
        Ahí se crean, se editan y se eliminan, junto a los envíos que las usan y las variables
        que rellenan.
      </p>
      <p className="mt-4">
        <a
          // `no-underline`: la hoja no trae `preflight`, así que un enlace con
          // pinta de botón sale subrayado si no se le quita.
          className={cn(estiloDeBoton({ variant: 'primary' }), 'no-underline')}
          href="#notificaciones/plantillas"
        >
          <i className="bi bi-box-arrow-up-right" aria-hidden="true" /> Abrir plantillas de correo
        </a>
      </p>
    </Card>
  );
}
